import { connect } from 'react-redux';
import { toastsActions } from '@zola-helpers/client';
import type { ToastAction } from '@zola-helpers/client/dist/types/redux/toasts/toastActionTypes';

import { getGuestCollectionSavedImg } from 'selectors/guestCollection';
import { getWeddingAccountHash } from 'selectors/wedding';

import ManageAddressCollectionLink from './ManageAddressCollectionLink';
import type { RootState, AppDispatch } from '../../../../../reducers';

export type ManageAddressCollectionLinkStateProps = {
  guestCollectionImg?: string;
  hashId?: string;
};

const mapStateToProps = (state: RootState): ManageAddressCollectionLinkStateProps => ({
  guestCollectionImg: getGuestCollectionSavedImg(state),
  hashId: getWeddingAccountHash(state),
});

export type ManageAddressCollectionLinkDispatchProps = {
  onCopy: () => ToastAction;
};

const mapDispatchToProps = (dispatch: AppDispatch): ManageAddressCollectionLinkDispatchProps => ({
  onCopy: () => dispatch(toastsActions.positive({ headline: 'Your Magic Link was copied!' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageAddressCollectionLink);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLink/index.ts